// src/pages/Products.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';

const products = [
  {
    id: 1,
    title: 'Billing Software',
    description: 'Streamline your invoicing process with our comprehensive billing solution.',
    features: [
      'Automated invoice generation',
      'Payment tracking and reminders',
      'Tax calculation and reporting',
      'Multi-currency support',
      'Integration with popular payment gateways',
      'Customizable invoice templates'
    ],
    image: '/api/placeholder/600/400',
    icon: '📊'
  },
  {
    id: 2,
    title: 'Hospital Management System',
    description: 'A complete solution for managing healthcare facilities efficiently.',
    features: [
      'Patient registration and records management',
      'Appointment scheduling',
      'Billing and insurance processing',
      'Pharmacy and inventory management',
      'Lab test management',
      'Staff management and payroll'
    ],
    image: '/api/placeholder/600/400',
    icon: '🏥'
  },
  {
    id: 3,
    title: 'Hotel Management System',
    description: 'Optimize your hotel operations with our comprehensive management solution.',
    features: [
      'Reservation and booking management',
      'Guest check-in and check-out',
      'Room inventory and housekeeping',
      'POS integration for restaurants and services',
      'Staff management and scheduling',
      'Reporting and analytics'
    ],
    image: '/api/placeholder/600/400',
    icon: '🏨'
  },
  {
    id: 4,
    title: 'E-commerce Platform',
    description: 'Launch your online store with our scalable e-commerce solution.',
    features: [
      'Product catalog management',
      'Shopping cart and checkout',
      'Payment processing',
      'Order management and tracking',
      'Customer account management',
      'Analytics and reporting'
    ],
    image: '/api/placeholder/600/400',
    icon: '🛒'
  },
  {
    id: 5,
    title: 'School Management System',
    description: 'A comprehensive solution for educational institutions.',
    features: [
      'Student enrollment and records',
      'Attendance tracking',
      'Grade management',
      'Course scheduling',
      'Fee management',
      'Parent-teacher communication'
    ],
    image: '/api/placeholder/600/400',
    icon: '🎓'
  },
  {
    id: 6,
    title: 'Inventory Management',
    description: 'Track and manage your inventory efficiently with our robust system.',
    features: [
      'Stock tracking and alerts',
      'Purchase order management',
      'Barcode/QR code scanning',
      'Multi-location inventory',
      'Reporting and analytics',
      'Supplier management'
    ],
    image: '/api/placeholder/600/400',
    icon: '📦'
  }
];

const Products = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Products</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Discover our range of customizable software solutions designed to meet the unique needs of your business.
          </p>
        </div>
        
        {/* Product List */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <Card key={product.id} className="flex flex-col h-full transition-transform hover:scale-105">
              {/* <div className="bg-gray-200 rounded-md mb-4 overflow-hidden">
                <img src={product.image} alt={product.title} className="w-full h-48 object-cover" />
              </div> */}
              
              <div className="flex-grow">
                <div className="flex items-center mb-3">
                  <span className="text-3xl mr-2">{product.icon}</span>
                  <h2 className="text-xl font-bold text-gray-800">{product.title}</h2>
                </div>
                
                <p className="text-gray-600 mb-4">{product.description}</p>
                
                <h3 className="font-semibold text-gray-800 mb-2">Key Features:</h3>
                <ul className="list-disc list-inside text-gray-600 mb-6">
                  {product.features.slice(0, 4).map((feature, index) => (
                    <li key={index} className="mb-1">{feature}</li>
                  ))}
                </ul>
              </div>
              
              <Link to={`/contact`} className="mt-auto">
                <Button className="w-full">Inquire Now</Button>
              </Link>
            </Card>
          ))}
        </div>
        
        {/* CTA Section */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-indigo-800 rounded-lg shadow-lg p-8 text-center text-white">
          <h2 className="text-2xl font-bold mb-4">Need a Custom Solution?</h2>
          <p className="text-lg mb-6 max-w-2xl mx-auto">
            We can tailor any of our products to fit your specific requirements or build a completely custom solution from scratch.
          </p>
          <Link to="/contact">
            <Button variant="outline" className="border-white text-white hover:bg-white hover:text-blue-600">
              Contact Us for Custom Development
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Products;